import { useCallback } from 'react';
import { useSelector } from 'react-redux';

const useAccessControl = () => {
	const roles = useSelector((state) => state.systemRoles);

	const isAuthorized = useCallback(
		(path) => {
			if (path === undefined) return true;
			let isAuth = false;

			if (Array.isArray(path)) {
				for (const el of path) {
					if (roles?.includes(el)) {
						isAuth = true;
						break;
					}
				}
			} else {
				isAuth = roles?.includes(path) ?? false;
			}
			return isAuth;
		},
		[roles]
	);

	return isAuthorized;
};

export default useAccessControl;
